import styled from 'styled-components'

export default styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 25px;
  margin: 27px 0 0 226px;
`
